import { useDispatch } from 'react-redux';
import { IconButton, Tooltip } from '@mui/material';

import { type MiddlewhereFilter } from '../filter/FilterItemManager';
import useSettings from '../hooks/useSettings';
import Icon from '../Icon';
import { showReportingDialog } from './ReportingDialog';

interface ExportButtonProps {
	module: string;
	filters?: MiddlewhereFilter[];
	query?: any;
}

export default function ExportButton({ module, filters, query }: ExportButtonProps) {
	const dispatch = useDispatch();
	const { sysSettings, t } = useSettings();

	function exportItems() {
		dispatch(
			showReportingDialog({
				module,
				folder: 'list',
				defaultParameters: [
					{ id: 'REPORT_DATA_ADAPTER', state: { value: sysSettings.report_dataadapter_path } },
					{ id: 'FILTERS_JSON', state: { value: JSON.stringify(filters) } },
					{ id: 'QUERY_JSON', state: { value: JSON.stringify(query) } }
				]
			})
		);
	}

	return (
		<Tooltip title={t('VIEW_HEADER_BUTTON_EXPORT')} arrow>
			<IconButton size="small" onClick={exportItems}>
				<Icon icon="file-export" />
			</IconButton>
		</Tooltip>
	);
}
